import React, { useContext, useEffect } from 'react';
import { Typography } from '@mui/material';
import { cloneDeep } from 'lodash';
import { assign } from 'xstate';
import { IntlShape } from 'react-intl';

import { BaseComponent } from '../Component';
import { SendContext } from '../../SendContext';
import { MachineContext } from '../../MachineContext';
import { translateWithFallback } from '../../util';

import { EvoachButton } from './EvoachButton';
export interface NextButtonComponent extends BaseComponent {
  type: 'nextButton';
  props: NextButtonProps;
}
export interface NextButtonProps {
  buttonText: string;
  /**
   * has to be false by default as Creator editor hangs up with set to true
   * Is hard-coded set to true in renderAction, .i.e., for player only
   */
  autoFocus?: boolean;
}
export const NextButton: React.FC<NextButtonProps> = ({
  buttonText,
  autoFocus = false,
}) => {
  const { send } = useContext(SendContext);

  const sendNextToContext = () => {
    send({
      type: 'writeToContext',
      payload: { ['evoach.interactiveecho']: buttonText },
    });
    send({
      type: 'next',
    });
  };

  useEffect(() => {
    if (!autoFocus) return;

    const listener = (event: any) => {
      if (event.code === 'Enter' || event.code === 'NumpadEnter') {
        event.preventDefault();
        sendNextToContext();
      }
    };
    document.addEventListener('keydown', listener);
    return () => {
      document.removeEventListener('keydown', listener);
    };
  }, []);

  return (
    <EvoachButton onClick={sendNextToContext} autoFocus={autoFocus}>
      <Typography>{buttonText}</Typography>
    </EvoachButton>
  );
};

export const renderNextButtonAction = (intl: IntlShape) => {
  return assign((context: MachineContext, _event, actionMetadata) => {
    const newContext = cloneDeep(context);
    newContext.widgetData = newContext.widgetData.filter(
      (element) => !element.temporary
    );
    newContext.widgetData.push({
      type: 'nextButton',
      temporary: actionMetadata.action.temporary ?? false,
      props: {
        autoFocus: true,
        buttonText: translateWithFallback(
          intl,
          actionMetadata.action.payload.buttonText
        ),
      },
    });
    return newContext;
  });
};
